import { render, staticRenderFns } from "./AgentActiveChip.vue?vue&type=template&id=36ed0b32&scoped=true"
import script from "./AgentActiveChip.vue?vue&type=script&lang=js"
export * from "./AgentActiveChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed0b32",
  null
  
)

export default component.exports